<template>
  <b-card class="container--info-WhatsApp m-0">
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col cols="12">
          <h1 class="title--delivery-id">Tu envío Nº {{ dataProps.delivery }}</h1>
          <h2 class="title--delivery-status">
            <feather-icon icon="CircleIcon" size="12" class="icon--circle"/>
            {{ dataProps.status }}
          </h2>
          <div class="line"></div>
          <div class="information--container">
            <feather-icon icon="InfoIcon" variant="flat-primary"/>
            <p class="m-0 information--container-text">
              Verifica en el mapa que la ubicación sea correcta. Luego, vuelve a WhatsApp y confirma la dirección para que podamos proceder con el siguiente intento de entrega. Si no lo haces, la dirección no se actualizará.
            </p>
          </div>
        </b-col>
      </b-row>
  
      <b-row class="justify-content-center">
        <b-col cols="12" md="6">
          <h2 class="title--section">Dirección de entrega</h2>
          <div class="information--section">
            {{ dataProps.address }}
          </div>
          <h2 class="title--section">Información adicional (depto, bloque, indicaciones, etc)</h2>
          <div class="information--section">
            {{ dataProps.ref }}
          </div>
          <h2 class="title--section">Teléfono</h2>
          <div class="information--section">
            {{ dataProps.phone_number }}
          </div>
        </b-col>
  
        <b-col cols="12" md="6">
          <b-card class="m-0">
            <google-map-vue
              :noMarker="mapOptions.noMarker"
              :infoMap="mapOptions.infoMap"
              :size="mapOptions.size"
              :full_address.sync="dataProps.address">
            </google-map-vue>
          </b-card>
        </b-col>
      </b-row>
  
      <b-row class="justify-content-center">
        <b-col cols="12" md="10" class="text-center">
          <b-button @click="openWhatsApp" class="w-100 w-md-auto button-whatsApp">Regresar a WhatsApp</b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import GoogleMapVue from '@/views/components/custom/map/GoogleMap.vue'
import {
  BContainer,
  BRow,
  BCol
} from 'bootstrap-vue'
export default {
  name: 'DeliveryForm',
  data() {
    return {
      mapOptions: {
        showMap: false,
        noMarker: false,
        infoMap: {
          draggable: false,
          icon:{
            url: 'https://storage.googleapis.com/tickets-misc/external_form_assets/Icono_Punto%20de%20Entrega.svg',
            scaledSize: {width: 80, height: 80}
          }
        },
        size: {
          'height': '42vh',
          'max-width': '100%',
          'margin-left': 'auto',
          'margin-right': 'auto'
        }
      }
    }
  },
  components: {
    GoogleMapVue,
    BContainer,
    BRow,
    BCol
  },
  computed: {
    dataProps() {
      const data = this.$route.query
      return {
        delivery: data.delivery,
        address: data.address,
        fordward_phone_number: data.fordward_phone_number,
        phone_number: data.phone_number,
        ref:  data.ref,
        status: data.status
      }
    }
  },
  methods: {
    openWhatsApp() {
      const url = `https://api.whatsapp.com/send/?phone=${this.dataProps.fordward_phone_number}&type=phone_number&app_absent=0`
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  .container--info-WhatsApp {
    min-height: 100vh;

    .icon--circle {
      fill: #DC6069;
      color: #DC6069;
    }

    .title--delivery-id,
    .title--delivery-status,
    .title--section,
    .button-whatsApp {
      font-family: Roboto;
      line-height: 100%;
      letter-spacing: 0%;
    }

    .title--delivery-id {
      font-weight: 700;
      font-size: 14px;
      color: #4A5568;
    }

    .title--delivery-status {
      font-weight: 400;
      font-size: 12px;
      color: #6D6B7A;
    }

    .information--container {
      background: #B9D5F4;
      border-radius: 4px;
      padding: 6px;
      color: #0169DE;
      display: grid;
      grid-template-columns: 20px 1fr;
      font-size: 12px;
      align-items: center;

      &-text {
        font-family: Roboto;
        font-weight: 400;
        font-size: 10px;
        color: #718096;
      }
    }

    .line {
      border: 0.5px solid #EBE9F1;
      height: 1px;
      margin: 15px 0;
    }

    .title--section,
    .information--section {
      margin: 15px 0;
    }

    .title--section {
      font-weight: 400;
      font-size: 12px;
    }
    .information--section {
      background: rgba(185, 185, 199, 0.12);
      padding: 6px;
      border: .5px solid #B9B9C7;
      border-radius: 4px;
      font-weight: 300;
      font-size: 12px;
      color: #5C5C5C;
    }
    .button-whatsApp {
      background-color: #27D045 !important;
      border-color: #27D045 !important;
      font-weight: 400;
      font-size: 12px;
      text-align: center;


      &:hover {
        background-color: #239538 !important;
        border-color: #239538 !important;
      }
    }
  }
</style>
